import { render } from "./PhoneNumberFormField.vue?vue&type=template&id=0f64b4c8"
import script from "./PhoneNumberFormField.vue?vue&type=script&lang=js"
export * from "./PhoneNumberFormField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__